export const getAdminWellList = (state) => {
  return state.wellList;
};

export const getWellEditModal = (state) => {
  const { showWellEntryModal } = getAdminWellList(state);
  return showWellEntryModal;
};

export const getWellMergeModal = (state) => {
  const { showWellMergeModal } = getAdminWellList(state);
  return showWellMergeModal;
};

export const getSelectedWell = (state) => {
  const { well } = getAdminWellList(state);
  return well;
};

export const getSelectedWellId = (state) => {
  const well = getSelectedWell(state);
  if (!well) {
    return null;
  }
  return well.id;
};
